/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, NgZone } from '@angular/core';

declare global {
  interface Window {
    Razorpay: any;
  }
}

/**
 * Thin wrapper around the Razorpay Checkout widget (loaded globally via the
 * `checkout.razorpay.com/v1/checkout.js` script tag in index.html).
 *
 * Runs the widget's callbacks back inside Angular's zone so change detection
 * picks up the result, and resolves/rejects a Promise instead of relying on
 * the caller to wire up `handler`/`modal.ondismiss` itself.
 */
@Injectable({
  providedIn: 'root'
})
export class RazorpayCheckoutService {
  constructor(private zone: NgZone) {}

  /**
   * Opens Razorpay Checkout with the given options and resolves with the
   * payment response on success, or rejects on failure/cancellation.
   *
   * @param options - Razorpay Checkout options (key, amount, currency, order_id, ...).
   */
  open(options: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const instance = new window.Razorpay({
        ...options,
        handler: (response: any) => this.zone.run(() => resolve(response)),
        modal: {
          ...(options.modal || {}),
          ondismiss: () => this.zone.run(() => reject(new Error('Payment was cancelled.'))),
        },
      });
      instance.on('payment.failed', (error: any) => this.zone.run(() => reject(error)));
      instance.open();
    });
  }
}
